import React from "react";
import { BodySVGs, HairSVGs, ClothesSVGs } from "./iserbaAvatarIconsMap";

const IserbaAvatarViewer = ({ player }) => {
	if (!player) return null;

	return (
		<div className="flex h-min items-end">
			<div className="h-[60px] w-[80px] flex items-center justify-center overflow-hidden">
				<svg viewBox="0 -20 40 80">
					{BodySVGs[player.avatar.gender](player.avatar.skin_color)}
					{HairSVGs[player.avatar.gender][player.avatar.hair_shape](
						player.avatar.hair_color
					)}
					{ClothesSVGs[player.avatar.gender][player.avatar.clothes]()}
				</svg>
			</div>

			{player.pseudo && (
				<div className="mt-2 text-xs font-bold">{player.pseudo}</div>
			)}
		</div>
	);
};

export default IserbaAvatarViewer;
